module.exports = __webpack_public_path__ + "static/media/interior_Design.957c9602.jpg";